export const ERROR_MESSAGES = {
  "email-already-exists": "Este correo ya ha sido registrado",
  "Usuario no existe": "El usuario que ingresaste, no existe",
};

export const SUCCESS_MESSAGES = {
  USER_CREATED_SUCCESSFULLY: "user-inserted-correctly",
};
